import type { ShiptoDepositCrud } from '@diamond/shared/schema/shipto-deposit';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getShiptoDepositBalance } from '../queries/shipto-deposit';
import { useAuthStore, useShipToStore } from '../stores';
import { useNominalLebihBayarEnabled } from './useNominalLebihBayarEnabled';

const BALANCE_STALE_TIME_MS = 60_000;

export function getShiptoDepositBalanceOptions(
  accessToken: string,
  warehouseId: string,
  isNlbEnabled: boolean
) {
  return queryOptions<ShiptoDepositCrud['getBalance']['response']>({
    queryKey: ['shipto-deposit-balance', warehouseId],
    queryFn: () => getShiptoDepositBalance(accessToken, warehouseId),
    enabled: isNlbEnabled && !!accessToken && !!warehouseId,
    staleTime: BALANCE_STALE_TIME_MS,
  });
}

export function useShiptoDepositBalance() {
  const accessToken = useAuthStore((state) => state.access_token);
  const warehouseId = useShipToStore((state) => state.selectedShipToId);
  const isNlbEnabled = useNominalLebihBayarEnabled();

  return useQuery(
    getShiptoDepositBalanceOptions(accessToken, warehouseId, isNlbEnabled)
  );
}
